import http from '@/biz/http.mjs'
import openWindow from '@/script/openWindow.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonCompareFirst(props) {
    const map = useMapContext()
    const {pblType, prjId, sVer} = map.data

    if ('INCREMENT' !== pblType) {
        return null
    }

    const handleClick = async () => {
        const {bizNodeType, pkid} = map.root.data

        const {pkid: basMapVerId} = await runAsync(
            () => http.get('/basmapvers/firstVer', {pkid, prjId, sVer}),
            {action: '读取首次发布版'}
        )

        openWindow(
            '/DiffMap',

            {
                basMapVerId,
                tarDpId: pkid,
                type: bizNodeType,
            }
        )
    }

    return (
        <MenuButton
            onClick={handleClick}
            {...props}
        >
            对比初版
        </MenuButton>
    )
}
